import React from "react";
import { FormattedMessage } from "react-intl";
import { Container } from "./styles";
import { messages } from "./messages";

export const NoData = () => (
  <Container>
    <FormattedMessage {...messages.noData} />
  </Container>
);